module.exports = __webpack_public_path__ + "img/ch21_05_欢迎回来.6429fdf2.jpg";